<template>
    <div>
        <el-collapse v-model="activeNames" style="border:none">
            <template v-for="(element,index) in jsonData.list">
                <!-- tabs选项卡解析 -->
                <template v-if="element.type == 'tabs' && !element.options.hidden">
                    <el-tabs :key="element.key" type="border-card" :tab-position="element.options.tabposition" :class="element.options.customClass" v-model="element.model" @tab-click="tabClick">
                        <el-tab-pane v-for="(val, idx) in element.columns" :key="idx" :label="val.label" :name="val.label">
                            <recursiveComponent v-if="element.model == val.label" :jsonData='val'></recursiveComponent>
                        </el-tab-pane>
                    </el-tabs>
                </template>
                <!-- 栅格布局解析 -->
                <template v-if="element.type == 'grid' && !element.options.isvisible && permissionSetting(element.options.invisibleRoleList,'look') && !element.options.isvisible && !componentsIsShow(element,element.options.hideCondition)">
                    <!-- 带名字的栅格布局 -->
                    <el-collapse-item :key="index" :title="element.name" :name="element.name" v-if="element.name">
                        <el-row :key="element.key" :gutter="element.options.gutter" :justify="element.options.justify" :align="element.options.align" :class="element.options.customClass">
                            <el-col v-for="(val, idx) in element.columns" :span="val.span" :key="idx">
                                <recursiveComponent :jsonData='val'></recursiveComponent>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <!-- 不带名字的栅格布局 -->
                    <el-row :key="index" :gutter="element.options.gutter" :justify="element.options.justify" :align="element.options.align" v-if="!element.options.hidden && !element.name" :class="element.options.customClass">
                        <el-col v-for="(val, idx) in element.columns" :span="val.span" :key="idx">
                            <recursiveComponent :jsonData='val'></recursiveComponent>
                        </el-col>
                    </el-row>
                </template>
                <!-- 基础组件解析 -->
                <template v-if="element.type != 'table' && element.type != 'grid' && element.type != 'tabs'">
                    <widgetFormItem :key="index" :element="element"></widgetFormItem>
                </template>
                <!-- 子表解析 -->
                <template v-if="element.type == 'table' && element.options.issubtable && !componentsIsShow(element,element.options.hideCondition)">
                    <el-collapse-item :key="index" :title="element.name" :name="element.name" v-if="!!element.name">
                        <childTable ref="childTable" :key="index" :element="element" @childRowClick="childRowClick" @addLineBtn="addLineBtn"></childTable>
                    </el-collapse-item>
                    <childTable v-else ref="childTable" :key="index" :element="element" @childRowClick="childRowClick" @addLineBtn="addLineBtn"></childTable>
                </template>
            </template>
        </el-collapse>
    </div>
</template>

<script>
import widgetFormItem from "./widgetFormItem"
import childTable from "./childTable"
export default {
    name:"recursiveComponent",
    props:["jsonData"],
    components:{widgetFormItem,childTable},
    data(){
        return{

        }
    },
    computed:{
        //详情页面分组信息
        activeNames:{
            get: function() {
                var arr = []
                if (!!this.jsonData.list) {
                    this.jsonData.list.map((val) => {
                        if(!val.options.isfoldlayout){
                            arr.push(val.name)
                        }
                    })
                }
                return arr
            },
            set: function(val) {}
        },
        //主表信息
        detailInfos() {
            return this.$store.state.detailInfo
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
    methods:{
        //tab选项卡点击
        tabClick(){
            this.$store.commit('setisrequestChildTableData',false)
            this.$nextTick(()=>{
                this.$store.commit('setisrequestChildTableData',true)
            })
        },
        //多级子表切换数据联动
        childRowClick(childElement, row, parentElement) {
            console.log(childElement, row, parentElement)
            this.$refs.childTable.forEach((childRefItem) => {
                console.log(childRefItem)
                if (childRefItem.element.options.hierarchy > parentElement.options.hierarchy) {
                    childRefItem.initData()
                }
                if (childRefItem.element.options.uniqueIdentification == childElement.options.uniqueIdentification) {
                    childRefItem.getData('', row)
                    childRefItem.updateOperation(false)
                }
            })
        },
        //多级子表新建时初始化
        addLineBtn(element) {
            this.$refs.childTable.forEach((childRefItem) => {
                if (childRefItem.element.options.hierarchy > element.options.hierarchy) {
                    childRefItem.initData()
                }
            })
        },
        //权限设置判断方法
        permissionSetting(arr, str) {
            if (!!arr && arr.length != 0) {
                var newArr = [];
                for (var i = 0; i < arr.length; i++) {
                    newArr.push(arr[i].name)
                }
                var res = newArr.includes(this.$store.state.currentuser.roleName)
                if (str == 'look') {
                    return !res
                } else {
                    return res
                }
            } else {
                if (str == 'look') {
                    return true
                } else {
                    return false
                }
            }
        },
        //组件禁用、隐藏条件解析
        componentsIsShow(element, hideCondition) {
            var str = hideCondition
            if (!!hideCondition) {
                var arr = hideCondition.split('&&')
                var Arr = arr.map((arrItem) => {
                    if (arrItem.indexOf('||') !== -1) {
                        return arrItem.split("||")
                    } else {
                        return arrItem
                    }
                })
                var newArr = Arr.flat(Infinity)
                newArr.forEach((newArrItem) => {
                    if (newArrItem.indexOf('(') !== -1) {
                        newArrItem = newArrItem.substr(1, newArrItem.length)
                        str = this.componentsIsShowDetailFunction(newArrItem,str,element)
                    } else if (newArrItem.indexOf(')') !== -1) {
                        newArrItem = newArrItem.substr(0, newArrItem.length - 1)
                        str = this.componentsIsShowDetailFunction(newArrItem,str,element)
                    }
                    str = this.componentsIsShowDetailFunction(newArrItem,str,element)
                })
                if (str.indexOf(':') == -1) {
                    return eval(str)
                }
            } else {
                return false
            }
        },
        componentsIsShowDetailFunction(newArrItem,str,element,){
            if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
                var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
                var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
                if (filedValue.indexOf('currentuser:') !== -1) {
                    filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
                }
                if (this.detailInfos[Detailfiled] != filedValue) {
                    str = str.replace(newArrItem, true)
                } else {
                    str = str.replace(newArrItem, false)
                }
            }else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
                var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
                var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
                if (filedValue.indexOf('currentuser:') !== -1) {
                    filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
                }
                if (!!this.detailInfos[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
                    str = str.replace(newArrItem, true)
                } else {
                    str = str.replace(newArrItem, false)
                }
            } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
                var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
                var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
                if (!!this.detailInfos[Detailfiled]) {
                    str = str.replace(replaceStr, true)
                } else {
                    str = str.replace(replaceStr, false)
                }
            }
            return str
        },
    }
}
</script>

<style>

</style>